import momentTz from 'moment-timezone';

export const TIMEZONE_OPTIONS = Object.freeze(momentTz.tz.names().map(item => ({ value: item, label: item })));

export const DAYS_OF_THE_WEEK = Object.freeze([
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]);

export const SHORT_VIEW_DATETIME_FORMAT = 'MMM D, YYYY hh:mma';
export const STORED_DATETIME_FORMAT = 'MM/DD/YYYY HH:mm';
export const SHORT_VIEW_DATE_FORMAT = 'MMM D, YYYY';
export const SHORT_VIEW_TIME_FORMAT = 'hh:mma';
export const DATE_FORMAT = 'MM/DD/YYYY';
export const TIME_FORMAT = 'HH:mm';
